import { JWEInvalid } from '../util/errors.js';
var checkCekLength = function checkCekLength(cek, expected) {
  var actual = cek.byteLength << 3;
  if (actual !== expected) {
    throw new JWEInvalid("Invalid Content Encryption Key length. Expected ".concat(expected, " bits, got ").concat(actual, " bits"));
  }
};
export default checkCekLength;